import { render, staticRenderFns } from "./AdminNewNavbar.vue?vue&type=template&id=37acd158&scoped=true&"
import script from "./AdminNewNavbar.vue?vue&type=script&lang=js&"
export * from "./AdminNewNavbar.vue?vue&type=script&lang=js&"
import style0 from "./AdminNewNavbar.vue?vue&type=style&index=0&id=37acd158&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37acd158",
  null
  
)

export default component.exports